import { Container } from "rsuite"
import { useTranslation } from "react-i18next"
import { appVersion } from "@/client/config/constants"

const versionStyle: React.CSSProperties = {
    fontSize: '12px',
    position: 'fixed',
    top: 'calc(100% - 2em)',
    left: 'calc(100% - 11em)',
    width: '10em',
    textAlign: 'right',
    transform: 'translate(0, 0)',
}

export default function Version() {
    const { t } = useTranslation()

    return (
        <Container style={versionStyle}>
            {t('Version {version}').replace('{version}', appVersion)}
        </Container>
    )
}